import { Box } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Pages } from "../../utils";

export const LaunchPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(Pages.EVENTS);
  }, [navigate]);

  return <Box className="page launch-page" sx={{ minHeight: "100vh" }}></Box>;
};
